import Image from '../../../generic/Image';
import { Link } from 'gatsby';
import React from 'react';
import RichText from '../../../generic/RichText';
import styles from './index.module.scss';

/**
 * @param {{products: (import('../../../../context/Quote').InventoryType|import('../../../../context/Quote').BundleQuantifier)[]}} props
 * @returns {JSX.Element}
 */
export default function BundledProducts({ products = [] }) {
  if (!products || !products.length) return null;
  let groupedProducts = products.reduce(mergeEqual, {});
  return (
    <div className={styles.bundled}>
      <p className={styles.bundledHeader}>Included with this product</p>
      <ul className={styles.bundledList}>
        {Object.values(groupedProducts).map(products => {
          let [item] = products;
          let product;
          switch (item.__typename) {
            case 'ContentfulProductBundleQuantifier':
            case 'ContentfulProductBundle':
              product = item.product;
              break;
            default:
              product = item;
          }
          let link = ['/devices', product.devicePage?.slug].join('/');
          return <BundledProduct key={product.title} product={product} quantity={products.length} link={link} />;
        })}
      </ul>
    </div>
  );
}

function BundledProduct({ product, link, quantity }) {
  return (
    <li className={styles.bundledItemWrapper}>
      <Link to={link} className={styles.bundledItem}>
        <div className={styles.bundledImageWrapper}>
          <Image
            fluid={product.images[0].image.fluid}
            alt={product.images[0].image.description}
            style={{ objectFit: 'contain' }}
          />
        </div>
        <div className={styles.bundledHeaderWrapper}>
          {`${quantity > 1 ? `${quantity} x ` : ''}`}
          <RichText>{product?.heading}</RichText>
        </div>
      </Link>
    </li>
  );
}

/**
 * @param {object} existing
 * @param {import('../../../../context/Quote').InventoryType|import('../../../../context/Quote').BundleQuantifier} cur
 * @returns {object}
 */
function mergeEqual(existing, cur) {
  let { id } = cur;
  switch (cur.__typename) {
    case 'ContentfulProductBundleQuantifier': // to handle ContentfulProductBundleQuantifier while it still exists:
      let { product, quantity } = cur;
      let bundled = [quantity].map(() => product);
      return { ...existing, [id]: [...(existing[id] || []), ...bundled] };
    case 'ContentfulProductBundle':
    case 'ContentfulProduct':
      return { ...existing, [id]: [...(existing[id] || []), cur] };
    default:
      throw new Error(`invalid inventory item`);
  }
}

export { mergeEqual };
